import User from '../models/User';
import ResolutionCenter from '../models/ResolutionCenter';

export default class HomeController {
	/*@ngInject;*/
	constructor($scope, $timeout, $interval, $http, $location, $route, $routeParams, $sce, $window) {
		var content		= $window.translations,
			resCenter 	= new ResolutionCenter($window.resolution_initial_list);

		$scope.loc	 	= $location.search();

		$scope.content = content;

		$scope.resolution_center = {
			select_option	: [{name : 'Choose one...'}],
			initial_list 	: resCenter.getInitialList(),
			second_list 	: false,
			resolution 		: $sce.trustAsHtml('')
		};

		$scope.legalPagesInitial = () => {
			var actions = window.actions;

			$scope.legalContent = content[actions.content];

			if ($scope.loc.find) {
				$timeout(function(){
					var section 	= $('div#address'),
						position 	= section.offset().top;
					
					window.scrollTo(0, position);
					//console.log('Find position ', position);
				}, 100);
			}
		};

		$('.mt-checkbox input').on("change", function(e) {
            var isChecked 	= $(this).is(':checked'),
				button 		= $('#saml-terms-submit-btn');

            if (isChecked) {
                button.removeAttr('disabled');
                button.click(function(){
                	$scope.$apply(function(){
                        $scope.saml_terms_btn = true;
					});

                    $scope.samlAcceptTerms();
				});
			} else {
                button.attr('disabled', 'disabled');
                button.unbind("click");
			}
		});

		$('#res_center_initial').on("change", function(e) {
			var option 			= $("#res_center_initial option:selected"),
				option_selected	= $scope.resolution_center.initial_list[option.attr('key')];

			resCenter.getArticle(option_selected.article_id).then((value)=>{
				$scope.$apply(function(){
					$scope.article = $sce.trustAsHtml(value.article);
				});

				resCenter.getGroupById(value.resolution_group_id).then((group_value)=>{
					$scope.$apply(function(){
						$scope.resolution_group = group_value;
					});
				});
			});
		});
		
		$scope.menuClickedItem = ($event)=>{
			var link = $($event.target).parents('li').find('a').attr('href');
			
			$window.location.href = link;
		};

		$scope.scroll_to = (anchor)=>{
			var section		= $('#'+ anchor),
				position 	= section.offset().top;

			$('html, body').animate({
				scrollTop	: position
			}, 200);
		};

		$scope.samlAcceptTerms = () => {
			var user = new User($http);

			user.samlAcceptTerms({'policy_accepted' : true}).then((data)=>{
                $timeout(function() {
                    $scope.$apply(function () {
                        $scope.saml_terms_btn = false;
                    });

                    $window.location.href = '/user/dashboard';
                }, 1000);
			});

			console.log('User has accepted');
		};
	}
}
